export default __webpack_public_path__ + "static/media/4.69ba07b5.jpg";